var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"setting-section my-3 py-3"},[_c('b-form-group',{attrs:{"id":_vm.id,"label-cols-sm":"4","label":_vm.label,"label-for":_vm.labelFor}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }